import { User } from "./types";

export const AdminGroupName = "admin";
export const EmployerGroupName = "employer";
export const PersonalInformationRevealGroupName = "PersonalInformationReveal";

export function hasRevealAccess (user: User) {
    return user.groups.some(v => v === PersonalInformationRevealGroupName);
}

export function isAdmin (user: User) {
    return user.groups.some(v => v === AdminGroupName);
}

// isEmployer tests if a User has the 'employer' or 'admin' cognito group applied to them.
export function isEmployer (user: User) {
    return user.groups.some(v => v === EmployerGroupName || v === AdminGroupName);
}